import { DesignProp, LayoutProp } from "../PropCategories";

export const flexWrap = {
  prop: "style-attribute",
  name: "Wrapping",
  nameI18n: "builder_ui.prop_type.styles.item_wrapping",
  category: [DesignProp, LayoutProp],
  type: "flex-wrap",
  defaultValue: "nowrap",
  options: [
    {
      label: "Don't wrap",
      labelI18n: "builder_ui.prop_type.styles.item_wrapping_types.no_wrap",
      value: "nowrap",
    },
    {
      label: "Wrap",
      labelI18n: "builder_ui.prop_type.styles.item_wrapping_types.wrap",
      value: "wrap",
    },
    {
      label: "Wrap reversed",
      labelI18n: "builder_ui.prop_type.styles.item_wrapping_types.wrap_reverse",
      value: "wrap-reverse",
    },
  ],
} as const;
